const columns = [

  {
    title: '细项名称',
    dataIndex: 'optionName',
    key: 'optionName',
    width: '30%'
  },
  {
    title: '达标情况',
    dataIndex: 'standardSituation',
    key: 'standardSituation',
    align: 'center',
    width: '20%'
  },
  {
    title: '点评内容',
    dataIndex: 'commentContent',
    key: 'commentContent',
    align: 'center',
    editable: true,
    width: '50%'
  }
];

export default columns
